// extracted by mini-css-extract-plugin
module.exports = {"imageExhibition":"ImageExhibition_imageExhibition__BkJVM","imageContainer":"ImageExhibition_imageContainer__vFqxs","fullScreenButton":"ImageExhibition_fullScreenButton__FiCCc"};